$(function() {
  if ($('body.products.show').length < 1) return

  // init
  App.util.photoSwiperInit()
})
